/* eslint-disable max-len */

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { AbstractTemplateElementComponent } from './AbstractTemplateElementComponent';
// import { tag } from '../../utils/tag';
import { generateID } from '../../vendors/ngblib/utils/GUID';
import { GameActionEvent, GameActionType } from '../../constants/GameActionEvent';
import { createElFromString } from '../../utils/elements/createElFromString';
import { createButtonHtml } from '../../utils/elements/createButtonEl';
import { createPixelArrowHtml } from '../../utils/elements/createPixelArrowEl';
import YmSendGoal from '../../helpers/YmSendGoal';
import { YmEventGoals } from '../../constants/YmEventGoals';

// const title = (str) => {
//     const titleEl = tag('h2', 'h2');
//     const textEl = tag('span', 'monospace-print__text', str);
//     const setEl = tag(
//         'span',
//         'monospace-print__ch-set',
//         str
//             .split('')
//             .map((ch, i) => `<span class="ch" style="animation-delay: ${0.1 + i * 0.04}s; transition-delay: ${0.1 + i * 0.04}s;">${ch}</span>`)
//             .join('')
//     );

//     titleEl.classList.add('monospace-print');

//     titleEl.appendChild(textEl);
//     titleEl.appendChild(setEl);

//     return titleEl;
// };

export class SelectionSetComponent extends AbstractTemplateElementComponent {
    #data;
    #needExactly;
    #rootEl;
    #formEl;
    #buttonEl;
    #optionEls;
    #sliderEl;
    #warning;
    #selectedInputs;
    #optionType = 'none';
    #startWithSelectedIds = [];

    constructor(data, startWithSelection) {
        super();

        const { optionType, needExactly } = data;

        // console.log(startWithSelection, 'startWithSelection', startWithSelection ? startWithSelection.map((opt) => opt.id) : []);

        this.#data = data;
        this.#startWithSelectedIds = startWithSelection ? startWithSelection.map((opt) => opt.id) : [];
        this.#needExactly = optionType === 'radio' ? 1 : (needExactly || -1);
        this._needListeners = true;
    }

    _render(parentNode, insertBeforeNode) {
        const selectionId = generateID();
        const titleid = generateID();
        const {
            selectTitle, selectTitleShort, options, optionType, nextLabel
        } = this.#data;

        const createOptionHtml = (opt) => {
            const { id, label, image } = opt;

            return `
                <div class="select-set__slide swiper-slide">
                    <label class="select-set__option select-set__option--${id}">
                        <input class="select-set__option-input" name="${selectionId}" value="${id}" type="${optionType}" aria-label="${label}" hidden>
                        <img class="select-set__option-img" alt="${label}" src="${image}">
                        <span class="select-set__option-name">${label}</span>
                    </label>
                </div>
            `;
        };

        const buttonHtml = createButtonHtml({
            text: nextLabel,
            color: 'green',
            size: 'size-1',
            classes: 'select-set__button',
            attributes: { type: 'submit' }
        });

        const prevArrowHtml = createPixelArrowHtml({
            direction: 'left',
            classes: 'select-set__options-slider-arrow select-set__options-slider-arrow--prev',
            attributes: { type: 'button', 'aria-hidden': true }
        });

        const nextArrowHtml = createPixelArrowHtml({
            direction: 'right',
            classes: 'select-set__options-slider-arrow select-set__options-slider-arrow--next',
            attributes: { type: 'button', 'aria-hidden': true }
        });

        const rootHtml = `
            <section class="main__screen">
                <div class="select-set">
                    <div class="select-set__bg"></div>
                    <div class="select-set__content">
                        <form class="select-set__form">
                            <h2 id="${titleid}" class="select-set__title">${window.innerWidth < 768 ? selectTitleShort : selectTitle}</h2>
                            <swiper class="swiper select-set__options-slider">
                                <div class="swiper-wrapper">
                                    ${options.map((opt) => createOptionHtml(opt)).join('')}
                                </div>
                            </swiper>
                            ${buttonHtml}
                            ${prevArrowHtml}
                            ${nextArrowHtml}
                        </form>
                    </div>
                </div>
            </section>
        `;

        const rootEl = createElFromString(rootHtml);

        if (insertBeforeNode instanceof Node) {
            parentNode.insertBefore(rootEl, insertBeforeNode);
        } else {
            parentNode.appendChild(rootEl);
        }

        this.#optionType = optionType;

        this.#optionEls = Array.from(rootEl.querySelectorAll('.select-set__option-input'));
        this.#formEl = rootEl.querySelector('.select-set__form');
        this.#sliderEl = rootEl.querySelector('.select-set__options-slider');
        this.#rootEl = rootEl;
        this.#buttonEl = rootEl.querySelector('.button[type="submit"]');

        this.slider = new Swiper(this.#sliderEl, {
            slidesPerView: 1,
            watchSlidesProgress: true,
            modules: [Navigation],
            navigation: {
                nextEl: this.#rootEl.querySelector('.select-set__options-slider-arrow--next'),
                prevEl: this.#rootEl.querySelector('.select-set__options-slider-arrow--prev')
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 4
                }
            },
            on: {
                slideChange: (sw) => {
                    const { slidesPerView } = sw.params;

                    if (slidesPerView > 1) return;

                    this.#optionEls[sw.realIndex].checked = true;
                    this.#updateState();
                }
            }
        });

        return [rootEl];
    }

    _show() {
        super._show();

        if (this.#optionEls instanceof Array) this.#optionEls[0].focus();
    }

    _clear() {
        super._clear();
        this.#optionEls = null;
        this.#formEl = null;
        this.#rootEl = null;
        this.#buttonEl = null;
        this.#sliderEl = null;
    }

    _prepareToShow() {
        super._prepareToShow();

        const { slidesPerView } = this.slider.params;

        if (slidesPerView === 1) this.#optionEls[0].checked = true;

        this.#updateState();

        console.log('####slider', this.slider.params.slidesPerView);

    }

    _addListeners() {
        super._addListeners();

        this.#optionEls.forEach((el) => {
            el.addEventListener('change', () => {
                this.#updateState();
            });
        });

        this.#formEl.addEventListener('submit', (evt) => {
            evt.preventDefault();

            if (this.#warning) {
                this.dispatchEvent({
                    type: GameActionEvent,
                    action: {
                        type: GameActionType.WARNING,
                        message: this.#warning
                    }
                });

                return false;
            }

            YmSendGoal(YmEventGoals.FURTHER);

            this.dispatchEvent({
                type: GameActionEvent,
                action: {
                    type: GameActionType.SELECT,
                    selectedIds: this.#selectedInputs.map((el) => el.value)
                }
            });

            return false;
        });
    }

    #updateState() {
        const selected = this.#optionEls.filter((el) => el.checked);
        const { length } = selected;

        // eslint-disable-next-line no-nested-ternary
        this.#warning = length === this.#needExactly ? null
            : (this.#needExactly === 1
                ? 'Нужно выбрать один из вариантов'
                : `Нужно выбрать еще ${this.#needExactly - length} варианта`);
        this.#selectedInputs = selected;

        this.#optionEls.forEach((el) => {
            if (!el.parentNode) return;
            if (el.checked) {
                el.parentNode.classList.add('checked');
            } else {
                el.parentNode.classList.remove('checked');
            }
        });

        if (this.#warning) {
            this.#buttonEl.setAttribute('disabled', 'disabled');
            this.#buttonEl.classList.add('disabled');

            if (this.#optionType === 'checkbox') {
                this.#optionEls.forEach((el) => {
                    el.removeAttribute('disabled');
                    if (el.parentNode) el.parentNode.classList.remove('disabled');
                });
            }
        } else {
            this.#buttonEl.removeAttribute('disabled');
            this.#buttonEl.classList.remove('disabled');

            if (this.#optionType === 'checkbox') {
                this.#optionEls.forEach((el) => {
                    if (!el.checked) {
                        el.setAttribute('disabled', 'disabled');
                        if (el.parentNode) el.parentNode.classList.add('disabled');
                    } else {
                        el.removeAttribute('disabled');
                        if (el.parentNode) el.parentNode.classList.remove('disabled');
                    }
                });
            }
        }
    }

    getSyncBoundingRect() {
        return this.#formEl ? this.#formEl.getBoundingClientRect() : null;
    }
}
